var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRChDboLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#EE3D85"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.155L8 15.155 15 15.155z",
    transform: "translate(-597.000000, -270.000000) translate(589.000000, 260.000000) translate(11.500000, 12.655173) rotate(-180.000000) translate(-11.500000, -12.655173)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRChDboLn);
export default __webpack_public_path__ + "static/media/rChDboLn.91498ad7362372790edc5bde1f9e06d9.svg";
export { ForwardRef as ReactComponent };